<template>
    <div>
        <template v-if="hasExtras">
            <table class="w-100 dark mb-4">
                <tr class="fs-small">
                    <th class="extraNameWidth"></th>
                    <th class="pb-2 text-center">Availability</th>
                    <th class="pb-2 text-center">Price/unit</th>
                    <th class="addRemoveWidth"></th>
                </tr>

                <tr class="extraRow border-bottom-light border-top-light" v-for="extra in extrasArray" v-if="extra.component.componentType === 0">
                    <td class="darker fs-large pl-2">{{ extra.component.name }} - {{extra.componentPrice.name}}</td>
                    <td class="fs-small text-center">{{showAvailability(extra)}}</td>
                    <td class="fs-small text-center">{{ formatPrice(extra.componentPrice.grossprice) }} €</td>

                    <td class="d-flex flex-row justify-content-center py-2">
                        <span class="border-light py-2 px-3 radius-normal mx-2 text-center pointer" @click="changeExtraQtd2('remove', extra)"><i class="ico ico-minus dark fs-smaller m-0"></i></span>
                        <!-- <span class="border-light py-2 px-2 radius-normal mx-2 text-center darker font-weight-600" style="width: 2.2rem">{{extra.quantity}}</span> -->
                        <input type="number" placeholder="0" step="1" min="0" class="text-center fs-larger px-1 py-0 bg-lighter darker" style="width: 2.2rem" v-model="extra.quantity" @input="quantityChanged(extra)" @focus="extraFocused(extra)">
                        <span class="border-light py-2 px-3 radius-normal mx-2 text-center pointer" @click="changeExtraQtd2('add', extra)"><i class="ico ico-add dark fs-smaller m-0"></i></span>
                    </td>
                </tr>

                <tr class="fs-large">
                    <th class="pt-2 pl-2 extraNameWidth">Total</th>
                    <th class="pt-2 pb-2"></th>
                    <th class="pt-2 pb-2 text-center">{{formatPrice(getReservationCalculations.totalComponentGrossprice)}} €</th>
                    <th class="pt-2 addRemoveWidth text-center">{{totalExtras}}</th>
                </tr>
            </table>
        </template>

        <div v-else class="fs-large dark text-center p-2">
            There are no extras to show
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import { reservationsMixin } from '@/mixins/reservations'

    export default {
        data() {
            return {
                extrasArray: null,
                extraItemLoaction: null,
            }
        },
        props: {
            reservation: {
                type: Object
            },
        },
        created() {
            this.extrasArray = JSON.parse(JSON.stringify(this.reservation.event.eventComponents));

            this.extrasArray.map(bookingComponent => {
                bookingComponent.originalQuantity = bookingComponent.quantity;
                bookingComponent.quantity = 0;
            });

            if (this.reservation.bookingComponents.length > 0) {
                this.extrasArray.forEach( e => {
                    const findedBC = this.reservation.bookingComponents.find(bc => bc.componentPrice.id === e.componentPrice.id);
                    
                    if (findedBC) {
                        e.quantityAvailable = findedBC.quantityAvailable;
                        e.quantity = findedBC.quantity;
                    }
                });
            }
        },
        mixins:[
            reservationsMixin
        ],
        computed: {
            ...mapGetters([
                'getReservationCalculations',
            ]),
            totalExtras() {
                let total = 0;

                for(let extra of this.extrasArray){
                    if (extra.quantity && extra.component.componentType === 0) {
                        total += Number(extra.quantity);
                    }
                }

                this.$set(this.reservation, 'totalExtas', total);
                
                return total;
            },
            hasExtras() {
                return this.extrasArray && this.extrasArray.length > 0 && this.extrasArray.some(e => e.component.componentType === 0);
            }
        },
        methods: {
            ...mapActions([
                'setReservationCalculations'
            ]),
            showAvailability(extra) {
                if (extra.originalQuantity == 0) {
                    return 'unlimited';
                } else {
                    return extra.quantityAvailable;
                }
            },
            extraQtd2(extra) {
                return extra.quantity;
            },
            changeExtraQtd2(addRemove, extra) {
                if (this.isReservationReadOnly) {
                    this.readOnlyShowMessage();
                    
                    return false;
                }

                if (addRemove == 'add') {
                    // Is unlimied
                    if (extra.originalQuantity == 0) {
                        extra.quantity++;
                    } else {
                        if (extra.quantityAvailable > 0) {
                            extra.quantity++;
                            extra.quantityAvailable--;
                        }
                    }
                } else if (addRemove == 'remove') {
                    if (extra.quantity > 0) {
                        extra.quantity--;

                        // Not unlimied
                        if (extra.originalQuantity != 0) {
                            extra.quantityAvailable++;
                        }
                    }
                }
                
                this.syncBookingComponents();

                // Asks api for calculations
                this.setReservationCalculations(this.reservation);
            },
            quantityChanged(extra) {
                const raw = Number(extra.quantity);
                const entered = Number.isFinite(raw) && raw >= 0 ? Math.floor(raw) : 0;
                const isUnlimited = extra.originalQuantity === 0;

                // Unlimited: just normalises quantity and displays ‘unlimited’
                if (isUnlimited) {
                    extra.quantity = entered;
                    extra.quantityAvailable = 0;
                    
                    this.syncBookingComponents();
                    this.setReservationCalculations(this.reservation);
                    return;
                }

                // With limit: calculates the maximum selectable amount (available stock before selection)
                const original = Number(extra.originalQuantity) || 0;
                const booked = Number(extra.quantityBooked) || 0;
                const maxSelectable = Math.max(0, original - booked);

                if (entered > maxSelectable) {
                    extra.quantity = maxSelectable;
                    extra.quantityAvailable = 0;

                    this.$toasted.error('Selected quantity can not be higher than available quantity');
                } else {
                    extra.quantity = entered;
                    extra.quantityAvailable = maxSelectable - entered;
                }

                this.syncBookingComponents();
                this.setReservationCalculations(this.reservation);
            },
            syncBookingComponents() {
                const { channelType, channel } = this.reservation.currentChannelCommission;

                const items = this.extrasArray
                    .filter(e => Number(e.quantity) > 0)
                    .map(e => ({
                        ...JSON.parse(JSON.stringify(e)),
                        id: null,
                        channelType,
                        channel
                    }));

                if (Array.isArray(this.reservation.bookingComponents)) {
                    this.reservation.bookingComponents.splice(0, this.reservation.bookingComponents.length, ...items);
                } else {
                    this.$set(this.reservation, 'bookingComponents', items);
                }
            },
            extraFocused(extra) {
                // Fix to simulate "placeholder" with 0 value
                if (extra.quantity == 0) {
                    extra.quantity = null;
                }
            }
        }
    }
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// ExtraSelector.vue?358fb2e0